import { ApolloClient, createNetworkInterface } from 'react-apollo'

export const createClient = () => {
  const networkInterface = createNetworkInterface({
    uri: '/api/graphql',
    opts: {
      credentials: 'same-origin',
      headers: {
        'x-csrf-token': window.segment.csrf
      }
    }
  })
  return new ApolloClient({ networkInterface })
}



// WEBPACK FOOTER //
// ./graphql/index.js